function enhancePrivacy(root) {
  if (root.dataset.privacyReady) return;
  const content = root.querySelector(
    "[data-privacy-content], .shopify-policy__body",
  );
  if (!content) return;
  if (root.tagName !== "ARTICLE") {
    const articleRoot = document.createElement("article");
    [...root.attributes].forEach((attribute) =>
      articleRoot.setAttribute(attribute.name, attribute.value),
    );
    while (root.firstChild) articleRoot.append(root.firstChild);
    root.replaceWith(articleRoot);
    root = articleRoot;
  }
  root.dataset.privacyReady = "true";
  root.classList.add("priv-Policy");
  const title = root.querySelector("h1");
  if (title && !root.querySelector(".priv-Eyebrow")) {
    const label = document.createElement("p");
    label.className = "priv-Eyebrow";
    label.textContent = "Legal / Your privacy";
    title.parentNode.insertBefore(label, title);
  }
  const headings = [...content.querySelectorAll("h2")];
  const grid = document.createElement("div");
  grid.className = "priv-Layout";
  const article = document.createElement("div");
  article.className = "priv-Article page-Body";
  // Keep Shopify's existing policy text; the unverified draft is not served.
  content.replaceWith(grid);
  article.append(content);
  if (headings.length) {
    const nav = document.createElement("nav");
    nav.className = "priv-Contents";
    nav.setAttribute("aria-label", "Privacy policy contents");
    const label = document.createElement("p");
    label.className = "priv-Eyebrow";
    label.textContent = "Contents";
    nav.append(label);
    const list = document.createElement("ol");
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const slug = heading.textContent
          .trim()
          .toLowerCase()
          .replace(/^\d+[.\s]*/, "")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-|-$/g, "");
        heading.id = `privacy-${index + 1}-${slug || "section"}`;
      }
      const item = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link);
      list.append(item);
    });
    nav.append(list);
    grid.append(nav);
  }
  grid.append(article);
  content.querySelectorAll("table").forEach((table, index) => {
    const scroll = document.createElement("div");
    scroll.className = "priv-TableScroll";
    scroll.tabIndex = 0;
    scroll.setAttribute("role", "region");
    scroll.setAttribute("aria-label", `Privacy policy table ${index + 1}`);
    table.replaceWith(scroll);
    scroll.append(table);
  });
}
if (location.pathname.replace(/\/$/, "").endsWith("/privacy-policy")) {
  document
    .querySelectorAll("[data-privacy-policy], .shopify-policy__container")
    .forEach(enhancePrivacy);
}
document.addEventListener("shopify:section:load", (event) =>
  event.target
    .querySelectorAll("[data-privacy-policy]")
    .forEach(enhancePrivacy),
);
